import {
	CaseReducer,
	createAsyncThunk,
	createSlice,
} from "@reduxjs/toolkit";
import { IThunkApiExtra, RootState } from "../store";
import { STATUS } from "../globalContext/globalContext.interfaces";
import { RecoveryContext, RecoveryRequest, RecoveryResponse } from "../globalContext/recovery.interface";
import { recoveryService } from "src/api/recovery/service";

type RecoveryState = RecoveryContext

export const initialState: RecoveryState = {
	status: STATUS.init,
	codeSent: null,
	statusCode: 0,
	recoveryToken: '',
	email: '',
	recoveryAttemptsLeft: 5
};

export const sendRecoveryCode = createAsyncThunk<RecoveryResponse, RecoveryRequest>(
	'recovery/recovery',
	async (request: RecoveryRequest | undefined, thunkApi) => {
		const { rejectWithValue } = thunkApi;
		if (request === undefined) return rejectWithValue("Se esperaba el email del usuario.");

		const { email } = request ?? {};
		if (email === undefined || email === null || email === '') return rejectWithValue("El email no debe venir vacío.");

		const response = await recoveryService.sendRecoveryCode(request)
		return response;
	}
);

export const RecoverySlice = createSlice({
	name: 'recovery',
	initialState,
	reducers: {
		resetRecoveryStatus: (state) => {
			state.status = STATUS.init;
			state.statusCode = 0;
		},
		resetRecoveryState: (state) => {
			return initialState;
		}
	},
	extraReducers: builder => {
		builder.addCase(sendRecoveryCode.pending, (state) => {
			state.status = STATUS.pending;
		});
		builder.addCase(sendRecoveryCode.fulfilled, (state, action) => {
			state.status = STATUS.idle;
			state.statusCode = action.payload.statusCode;
			state.recoveryToken = action.payload.recoveryToken;
			state.recoveryAttemptsLeft = action.payload.recoveryAttemptsLeft;
		});
		builder.addCase(sendRecoveryCode.rejected, (state, action) => {
			state.status = STATUS.error;
		});
	}
});

export const selectStatus = (state: RootState) => state.RecoveryState.status;
export const selectCodeSent = (state: RootState) => state.RecoveryState.codeSent;
export const selectRecoveryToken = (state: RootState) => state.RecoveryState.recoveryToken;
export const selectStatusCode = (state: RootState) => state.RecoveryState.statusCode;
export const selectRecoveryAttempts = (state: RootState) => state.RecoveryState.recoveryAttemptsLeft;
export const { resetRecoveryStatus, resetRecoveryState } = RecoverySlice.actions;


